import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from '@lightspeed/flame/Button';
import Card from '@lightspeed/cirrus-card';
import { Divider } from '@lightspeed/flame/Divider';
import Group from '@lightspeed/cirrus-group';

const subject = "I'd like to schedule my onboarding!";
const body = ({ employeeName, shopName, phoneWork }) =>
  encodeURIComponent(
    `Hi, Lightspeed! I am a new customer${shopName ? ` from ${shopName}` : ''}.
I'd like to schedule an onboarding session.

Here is my contact information:
${shopName || ''}
${phoneWork || ''}

Thanks!
${employeeName || ''}`
  );

const CustomerAccount = ({
  setupGuide,
  addInventoryData,
  configureHardware,
  phone,
  tel,
  mailto,
  employeeName,
  shopName,
  phoneWork,
}) => (
  <Fragment>
    <Card className="cr-flex cr-items-center">
      <div>
        <img
          src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/getting-started/onboarding-customer.jpg"
          srcSet="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/getting-started/onboarding-customer@2x.jpg 2x, https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/getting-started/onboarding-customer@3x.jpg 3x"
          style={{ display: 'block' }}
          alt=""
        />
      </div>
      <div className="cr-p-4">
        <h1 className="cr-mb-0">Book a Lightspeed Retail onboarding session today!</h1>
        <p className="cr-text-s cr-gray-300 cr-mt-1 cr-mb-4">
          Get a FREE onboarding session with a Product Specialist.
          <br />
          We’ll help you set up Lightspeed Retail to work with your business.
        </p>
        <Group>
          <Button
            href={`mailto:${mailto}?subject=${subject}&body=${body({
              employeeName,
              shopName,
              phoneWork,
            })}`}
            variant="primary"
            fill
            size="large"
            style={{ color: '#fff' }}
          >
            Book now
          </Button>
          <span className="cr-text-s cr-gray-300">or call us</span>
          <a href={`tel:${tel}`} className="cr-text-l">
            {phone}
          </a>
        </Group>
      </div>
    </Card>
    <section className="cr-flex cr-justify-between cr-pv-4">
      <div>
        <h2 className="cr-mb-0">Follow the Lightspeed Retail Guided Setup</h2>
        <p className="cr-text-s cr-gray-300 cr-mv-0">
          All the help you need to start selling today.
        </p>
      </div>
      <Button href={setupGuide} target="_blank" variant="secondary">
        Get started
      </Button>
    </section>
    <div style={{ margin: '0 -1.5rem' }}>
      <Divider />
    </div>
    <section className="cr-flex cr-justify-between cr-pv-4">
      <div>
        <h2 className="cr-mb-0">Add inventory to your account</h2>
        <p className="cr-text-s cr-gray-300 cr-mv-0">Manually enter or import your data.</p>
      </div>

      <Button href={addInventoryData} target="_blank" variant="secondary">
        Add data
      </Button>
    </section>
    <div style={{ margin: '0 -1.5rem' }}>
      <Divider />
    </div>
    <section className="cr-flex cr-justify-between cr-pv-4">
      <div>
        <h2 className="cr-mb-0">Configure your hardware</h2>
        <p className="cr-text-s cr-gray-300 cr-mv-0">
          Set up your printers, scanners, cash drawers and more.
        </p>
      </div>
      <Button href={configureHardware} target="_blank" variant="secondary">
        Set up now
      </Button>
    </section>
  </Fragment>
);

CustomerAccount.propTypes = {
  setupGuide: PropTypes.string.isRequired,
  addInventoryData: PropTypes.string.isRequired,
  configureHardware: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  tel: PropTypes.string.isRequired,
  mailto: PropTypes.string.isRequired,
  employeeName: PropTypes.string,
  shopName: PropTypes.string,
  phoneWork: PropTypes.string,
};

CustomerAccount.defaultProps = {
  employeeName: '',
  shopName: '',
  phoneWork: '',
};

export default CustomerAccount;
